module.exports = "<div class=\"gw-producer-code-select__select\">\r\n    <select name=\"selectedProducerCode\"\r\n            ng-model=\"selectedProducerCode\"\r\n            ng-change=\"setSelectedProducerCode()\"\r\n            ng-options=\"item as item.displayValue for item in availableProducerCodes\">\r\n    </select>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/directives/ProducerCodeSelectDirective/producer-code-select.html
// module id = 752
// module chunks = 0